import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const Gateway = () => {
  const [RazorPayout, setRazorpayout] = useState(true);
  const [RazorDeposit, setRazorDeposit] = useState(true);
  const [RazorpayAuto, setRazorpayAuto] = useState(false);
  const [RazorPayKey, setRazorpayKey] = useState("");
  const [RazorPaySecretKey, setRazorpaysecretKey] = useState("");
  const [AccountName, setAccountName] = useState("");
  const [decentroPayout, setdecentropayout] = useState(true);
  const [decentroDeposit, setdecentroDeposit] = useState(true);
  const [decentroAuto, setdecentroAuto] = useState(false);
  const [settingId, setSettingId] = useState("");

  // Manual UPI & QR States
  const [ManualUPIID, setManualUPIID] = useState("");
  const [ManualQRCode, setManualQRCode] = useState("");
  const [isManualUPIEnabled, setIsManualUPIEnabled] = useState(true);
  const [minDeposit, setMinDeposit] = useState(10);
  const [maxDeposit, setMaxDeposit] = useState(20000);
  const [manualQrFile, setManualQrFile] = useState(null);
  const [manualQrPreview, setManualQrPreview] = useState("");
  const [isSavingManualUpi, setIsSavingManualUpi] = useState(false);

  // UPI States
  const [UPIEnabled, setUPIEnabled] = useState(true);
  const [UPIGatewayKey, setUPIGatewayKey] = useState("");
  const [UPIGatewaySecret, setUPIGatewaySecret] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Fast2SMS States
  const [fast2smsKey, setFast2smsKey] = useState("");
  const [Fast2SMSEnabled, setFast2SMSEnabled] = useState(true);

  // Twilio States
  const [TwilioEnabled, setTwilioEnabled] = useState(true);
  const [TwilioAccountSid, setTwilioAccountSid] = useState("");
  const [TwilioAuthToken, setTwilioAuthToken] = useState("");
  const [TwilioPhoneNumber, setTwilioPhoneNumber] = useState("");

  // OTPless States
  const [OTPlessEnabled, setOTPlessEnabled] = useState(false);
  const [OTPlessClientId, setOTPlessClientId] = useState("");
  const [OTPlessClientSecret, setOTPlessClientSecret] = useState("");
  const [OTPlessEnvironment, setOTPlessEnvironment] = useState("production");

  // SMSINDIAHUB States
  const [SMSINDIAHUBEnabled, setSMSINDIAHUBEnabled] = useState(false);
  const [SMSINDIAHUBAPIKey, setSMSINDIAHUBAPIKey] = useState("");
  const [SMSINDIAHUBSID, setSMSINDIAHUBSID] = useState("");
  const [SMSINDIAHUBName, setSMSINDIAHUBName] = useState("");

  // AllAPI States
  const [AllAPIEnabled, setAllAPIEnabled] = useState(false);
  const [AllAPIToken, setAllAPIToken] = useState("");
  const [AllAPISecretKey, setAllAPISecretKey] = useState("");
  const [AllAPIRedirectUrl, setAllAPIRedirectUrl] = useState("");

  // LudoRoom States
  const [LudoRoomEnabled, setLudoRoomEnabled] = useState(true);
  const [LudoRoomApiKey, setLudoRoomApiKey] = useState("");
  const [LudoRoomWebhookSecret, setLudoRoomWebhookSecret] = useState("");
  const [LudoRoomAutoRegister, setLudoRoomAutoRegister] = useState(true);
  const [ludoroomProfile, setLudoroomProfile] = useState(null);
  const [ludoroomLoading, setLudoroomLoading] = useState(false);
  const [ludoroomMsg, setLudoroomMsg] = useState("");

  const backendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const backendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = backendLocalApiUrl;
  } else {
    baseUrl = backendLiveApiUrl;
  }

  useEffect(() => {
    const data = axios.get(baseUrl + "gatewaysettings/data", {}).then((res) => {
      if (res.data) {
        setSettingId((res.data._id) ? res.data._id : '');
        setRazorpayout(res.data.RazorPayout !== undefined && res.data.RazorPayout !== null ? res.data.RazorPayout : true);
        setRazorDeposit(res.data.RazorDeposit !== undefined && res.data.RazorDeposit !== null ? res.data.RazorDeposit : true);
        setRazorpayAuto(res.data.RazorpayAuto !== undefined && res.data.RazorpayAuto !== null ? res.data.RazorpayAuto : false);
        setdecentropayout(res.data.decentroPayout !== undefined && res.data.decentroPayout !== null ? res.data.decentroPayout : true);
        setdecentroDeposit(res.data.decentroDeposit !== undefined && res.data.decentroDeposit !== null ? res.data.decentroDeposit : true);
        setdecentroAuto(res.data.decentroAuto !== undefined && res.data.decentroAuto !== null ? res.data.decentroAuto : false);
        setRazorpayKey(res.data.RazorPayKey || "");
        setRazorpaysecretKey(res.data.RazorPaySecretKey || "");
        setAccountName(res.data.AccountName || "");

        // UPI Data
        setUPIEnabled(res.data.UPIEnabled !== undefined ? res.data.UPIEnabled : true);
        setUPIGatewayKey(res.data.UPIGatewayKey || "");
        setUPIGatewaySecret(res.data.UPIGatewaySecret || "");

        // Fast2SMS Data
        setFast2smsKey(res.data.fast2smsKey || "");
        setFast2SMSEnabled(res.data.Fast2SMSEnabled !== undefined ? res.data.Fast2SMSEnabled : true);

        // Twilio Data
        setTwilioEnabled(res.data.TwilioEnabled !== undefined ? res.data.TwilioEnabled : true);
        setTwilioAccountSid(res.data.TwilioAccountSid || "");
        setTwilioAuthToken(res.data.TwilioAuthToken || "");
        setTwilioPhoneNumber(res.data.TwilioPhoneNumber || "");

        // OTPless Data
        setOTPlessEnabled(res.data.OTPlessEnabled !== undefined ? res.data.OTPlessEnabled : false);
        setOTPlessClientId(res.data.OTPlessClientId || "");
        setOTPlessClientSecret(res.data.OTPlessClientSecret || "");
        setOTPlessEnvironment(res.data.OTPlessEnvironment || "production");

        // SMSINDIAHUB Data
        setSMSINDIAHUBEnabled(res.data.SMSINDIAHUBEnabled !== undefined ? res.data.SMSINDIAHUBEnabled : false);
        setSMSINDIAHUBAPIKey(res.data.SMSINDIAHUBAPIKey || "");
        setSMSINDIAHUBSID(res.data.SMSINDIAHUBSID || "");
        setSMSINDIAHUBName(res.data.SMSINDIAHUBName || "");

        // AllAPI Data
        setAllAPIEnabled(res.data.AllAPIEnabled !== undefined ? res.data.AllAPIEnabled : false);
        setAllAPIToken(res.data.AllAPIToken || "");
        setAllAPISecretKey(res.data.AllAPISecretKey || "");
        setAllAPIRedirectUrl(res.data.AllAPIRedirectUrl || "");

        // LudoRoom Data
        setLudoRoomEnabled(res.data.LudoRoomEnabled !== undefined ? res.data.LudoRoomEnabled : true);
        setLudoRoomApiKey(res.data.LudoRoomApiKey || "");
        setLudoRoomWebhookSecret(res.data.LudoRoomWebhookSecret || "");
        setLudoRoomAutoRegister(res.data.LudoRoomAutoRegister !== undefined ? res.data.LudoRoomAutoRegister : true);

        // Manual UPI & QR Data
        setManualUPIID(res.data.ManualUPIID || "");
        setManualQRCode(res.data.ManualQRCode || "");
        setIsManualUPIEnabled(res.data.isManualUPIEnabled !== undefined ? res.data.isManualUPIEnabled : true);
        setMinDeposit(res.data.minDeposit || 10);
        setMaxDeposit(res.data.maxDeposit || 20000);
      }
    }).catch(err => console.error(err));
  }, []);

  const handleManualQrChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setManualQrFile(file);
      setManualQrPreview(URL.createObjectURL(file));
    }
  };

  const handleManualUpiSubmit = async (e) => {
    e.preventDefault();
    setIsSavingManualUpi(true);
    try {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const formData = new FormData();
      formData.append("ManualUPIID", ManualUPIID);
      formData.append("isManualUPIEnabled", isManualUPIEnabled);
      formData.append("minDeposit", minDeposit);
      formData.append("maxDeposit", maxDeposit);
      if (manualQrFile) {
        formData.append("ManualQRCode", manualQrFile);
      }

      const res = await axios.post(baseUrl + "api/admin/settings", formData, { headers });
      if (res.data.success) {
        if (res.data.ManualQRCode) {
          setManualQRCode(res.data.ManualQRCode);
        }
        setManualQrFile(null);
        setManualQrPreview("");
        Swal.fire({
          icon: "success",
          title: "Settings Saved!",
          text: "Manual UPI ID and QR Code have been updated successfully.",
          timer: 2500,
          showConfirmButton: false
        });
      } else {
        throw new Error(res.data.message || "Failed to update");
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: err.response?.data?.message || err.message || "Failed to update settings"
      });
    } finally {
      setIsSavingManualUpi(false);
    }
  };

  const handleUPIToggle = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(baseUrl + "gatewaysettings/toggle-upi");
      if (response.data.status === 'success') {
        setUPIEnabled(response.data.data.UPIEnabled);
        alert(response.data.message);
      } else {
        alert("Failed to toggle UPI status");
      }
    } catch (error) {
      console.error("Error toggling UPI:", error);
      alert("Error toggling UPI status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleFast2SMSToggle = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(baseUrl + "gatewaysettings/toggle-fast2sms");
      if (response.data.status === 'success') {
        setFast2SMSEnabled(response.data.data.Fast2SMSEnabled);
        setTwilioEnabled(response.data.data.TwilioEnabled); // Update Twilio state too
        setOTPlessEnabled(response.data.data.OTPlessEnabled); // Update OTPless state too
        setSMSINDIAHUBEnabled(response.data.data.SMSINDIAHUBEnabled); // Update SMSINDIAHUB state too
        alert(response.data.message);
      } else {
        alert("Failed to toggle Fast2SMS status");
      }
    } catch (error) {
      console.error("Error toggling Fast2SMS:", error);
      alert("Error toggling Fast2SMS status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleTwilioToggle = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(baseUrl + "gatewaysettings/toggle-twilio");
      if (response.data.status === 'success') {
        setTwilioEnabled(response.data.data.TwilioEnabled);
        setFast2SMSEnabled(response.data.data.Fast2SMSEnabled); // Update Fast2SMS state too
        setOTPlessEnabled(response.data.data.OTPlessEnabled); // Update OTPless state too
        setSMSINDIAHUBEnabled(response.data.data.SMSINDIAHUBEnabled); // Update SMSINDIAHUB state too
        alert(response.data.message);
      } else {
        alert("Failed to toggle Twilio status");
      }
    } catch (error) {
      console.error("Error toggling Twilio:", error);
      alert("Error toggling Twilio status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleOTPlessToggle = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(baseUrl + "gatewaysettings/toggle-otpless");
      if (response.data.status === 'success') {
        setOTPlessEnabled(response.data.data.OTPlessEnabled);
        setFast2SMSEnabled(response.data.data.Fast2SMSEnabled); // Update Fast2SMS state too
        setTwilioEnabled(response.data.data.TwilioEnabled); // Update Twilio state too
        setSMSINDIAHUBEnabled(response.data.data.SMSINDIAHUBEnabled); // Update SMSINDIAHUB state too
        alert(response.data.message);
      } else {
        alert("Failed to toggle OTPless status");
      }
    } catch (error) {
      console.error("Error toggling OTPless:", error);
      alert("Error toggling OTPless status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSMSINDIAHUBToggle = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(baseUrl + "gatewaysettings/toggle-smsindiahub");
      if (response.data.status === 'success') {
        setSMSINDIAHUBEnabled(response.data.data.SMSINDIAHUBEnabled);
        setFast2SMSEnabled(response.data.data.Fast2SMSEnabled); // Update Fast2SMS state too
        setTwilioEnabled(response.data.data.TwilioEnabled); // Update Twilio state too
        setOTPlessEnabled(response.data.data.OTPlessEnabled); // Update OTPless state too
        alert(response.data.message);
      } else {
        alert("Failed to toggle SMSINDIAHUB status");
      }
    } catch (error) {
      console.error("Error toggling SMSINDIAHUB:", error);
      alert("Error toggling SMSINDIAHUB status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAllAPIToggle = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(baseUrl + "gatewaysettings/toggle-allapi");
      if (response.data.status === 'success') {
        setAllAPIEnabled(response.data.data.AllAPIEnabled);
        alert(response.data.message);
      } else {
        alert("Failed to toggle AllAPI status");
      }
    } catch (error) {
      console.error("Error toggling AllAPI:", error);
      alert("Error toggling AllAPI status");
    } finally {
      setIsLoading(false);
    }
  };

  const handleLudoRoomToggle = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(baseUrl + "gatewaysettings/toggle-ludoroom");
      if (response.data.status === 'success') {
        setLudoRoomEnabled(response.data.data.LudoRoomEnabled);
        alert(response.data.message);
      } else {
        alert("Failed to toggle LudoRoom status");
      }
    } catch (error) {
      console.error("Error toggling LudoRoom:", error);
      alert("Error toggling LudoRoom status");
    } finally {
      setIsLoading(false);
    }
  };

  const testLudoRoomConnection = async () => {
    setLudoroomLoading(true);
    setLudoroomMsg("");
    setLudoroomProfile(null);
    try {
      const response = await axios.get(baseUrl + "api/v1/ludoroom/profile");
      if (response.data.success) {
        setLudoroomProfile(response.data.data);
        setLudoroomMsg("✅ Connected successfully to LudoRoom API!");
      } else {
        setLudoroomMsg(`❌ Failed: ${response.data.message || 'Unable to connect'}`);
      }
    } catch (err) {
      const msg = err.response?.data?.message || err.message;
      setLudoroomMsg(`❌ Error: ${msg}`);
    } finally {
      setLudoroomLoading(false);
    }
  };

  const handleSubmit1 = async (e) => {
    e.preventDefault();

    const response = await axios.post(
      baseUrl + `gatewaysettings`,
      {
        settingId,
        RazorPayout,
        RazorDeposit,
        RazorpayAuto,
        decentroPayout,
        decentroDeposit,
        decentroAuto,
        RazorPayKey,
        RazorPaySecretKey,
        AccountName,
        UPIEnabled,
        UPIGatewayKey,
        UPIGatewaySecret,
        fast2smsKey,
        Fast2SMSEnabled,
        TwilioEnabled,
        TwilioAccountSid,
        TwilioAuthToken,
        TwilioPhoneNumber,
        OTPlessEnabled,
        OTPlessClientId,
        OTPlessClientSecret,
        OTPlessEnvironment,
        SMSINDIAHUBEnabled,
        SMSINDIAHUBAPIKey,
        SMSINDIAHUBSID,
        SMSINDIAHUBName,
        AllAPIEnabled,
        AllAPIToken,
        AllAPISecretKey,
        AllAPIRedirectUrl,
        LudoRoomEnabled,
        LudoRoomApiKey,
        LudoRoomWebhookSecret,
        LudoRoomAutoRegister,
      }
    );
    if (response.data.status === 'success') {
      alert("Settings submitted successfully");
    } else {
      alert("Settings Not Submitted");
    }
  };

  return (
    <>
      {/* Manual UPI & QR Gateway Settings Section */}
      <div className="d-flex align-items-center justify-content-between my-3">
        <h5 className="text-uppercase font-weight-bold mb-0 text-white" style={{ letterSpacing: "0.5px" }}>
          ⚡ Manual UPI & QR Deposit Gateway (Pay Direct)
        </h5>
        <span
          className={`badge ${isManualUPIEnabled ? "badge-success" : "badge-danger"}`}
          style={{ padding: "6px 12px", fontSize: "0.85rem", fontWeight: "bold" }}
        >
          {isManualUPIEnabled ? "● Pay Direct Active" : "○ Pay Direct Disabled"}
        </span>
      </div>

      <form
        className="form"
        onSubmit={handleManualUpiSubmit}
        style={{
          background: "linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.95) 100%)",
          padding: "24px",
          borderRadius: "12px",
          marginBottom: "24px",
          border: "1px solid rgba(56, 189, 248, 0.3)",
          boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.4)"
        }}
      >
        <div className="row">
          {/* Left Column: UPI ID and Limits */}
          <div className="col-lg-7">
            <div className="form-group mb-3">
              <div className="d-flex align-items-center mb-2">
                <label className="mr-3 mb-0 font-weight-bold text-white" style={{ minWidth: "140px" }}>
                  Gateway Status:
                </label>
                <button
                  type="button"
                  className={`btn btn-sm ${isManualUPIEnabled ? "btn-success" : "btn-danger"} font-weight-bold`}
                  onClick={() => setIsManualUPIEnabled(!isManualUPIEnabled)}
                  style={{ minWidth: "110px", borderRadius: "8px", padding: "6px 14px" }}
                >
                  {isManualUPIEnabled ? "✓ Active (Enabled)" : "✕ Disabled"}
                </button>
                <small className="ml-3 text-muted">
                  {isManualUPIEnabled
                    ? "Users can see QR code and submit UTR deposit requests"
                    : "Pay Direct option is hidden from users"}
                </small>
              </div>
            </div>

            <div className="form-group mb-3">
              <label htmlFor="ManualUPIID" className="font-weight-bold text-white mb-1">
                Manual UPI ID / VPA <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <input
                  id="ManualUPIID"
                  className="form-control"
                  type="text"
                  value={ManualUPIID}
                  onChange={(e) => setManualUPIID(e.target.value)}
                  placeholder="e.g. yourbusiness@okhdfcbank or merchant@upi"
                  required
                  style={{
                    backgroundColor: "rgba(255,255,255,0.06)",
                    borderColor: "rgba(255,255,255,0.15)",
                    color: "#38bdf8",
                    fontWeight: "600",
                    fontFamily: "monospace"
                  }}
                />
              </div>
              <small className="form-text text-muted">
                Users will copy this UPI ID to make payments in PhonePe, GPay, Paytm, etc.
              </small>
            </div>

            <div className="form-row">
              <div className="form-group col-md-6 mb-3">
                <label htmlFor="minDeposit" className="font-weight-bold text-white mb-1">
                  Min Deposit (₹)
                </label>
                <input
                  id="minDeposit"
                  className="form-control"
                  type="number"
                  min="1"
                  value={minDeposit}
                  onChange={(e) => setMinDeposit(e.target.value)}
                  placeholder="e.g. 10"
                  style={{
                    backgroundColor: "rgba(255,255,255,0.06)",
                    borderColor: "rgba(255,255,255,0.15)",
                    color: "#fff"
                  }}
                />
              </div>

              <div className="form-group col-md-6 mb-3">
                <label htmlFor="maxDeposit" className="font-weight-bold text-white mb-1">
                  Max Deposit (₹)
                </label>
                <input
                  id="maxDeposit"
                  className="form-control"
                  type="number"
                  min="1"
                  value={maxDeposit}
                  onChange={(e) => setMaxDeposit(e.target.value)}
                  placeholder="e.g. 20000"
                  style={{
                    backgroundColor: "rgba(255,255,255,0.06)",
                    borderColor: "rgba(255,255,255,0.15)",
                    color: "#fff"
                  }}
                />
              </div>
            </div>

            <div className="form-group mb-3">
              <label htmlFor="ManualQRCodeInput" className="font-weight-bold text-white mb-1">
                Upload / Replace QR Code Image
              </label>
              <input
                id="ManualQRCodeInput"
                className="form-control-file text-white p-2"
                type="file"
                accept="image/png, image/jpeg, image/jpg, image/webp"
                onChange={handleManualQrChange}
                style={{
                  backgroundColor: "rgba(255,255,255,0.04)",
                  border: "1px dashed rgba(255,255,255,0.2)",
                  borderRadius: "8px"
                }}
              />
              <small className="form-text text-muted">
                Accepts PNG, JPG, or WebP. Recommended: Square image (500x500px).
              </small>
            </div>

            <button
              type="submit"
              className="btn btn-primary font-weight-bold mt-2"
              disabled={isSavingManualUpi}
              style={{
                borderRadius: "8px",
                padding: "10px 24px",
                background: "linear-gradient(135deg, #0284c7, #2563eb)",
                border: "none",
                boxShadow: "0 4px 12px rgba(37, 99, 235, 0.4)"
              }}
            >
              {isSavingManualUpi ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-2" role="status"></span>
                  Saving Settings...
                </>
              ) : (
                "💾 Save Manual UPI & QR Settings"
              )}
            </button>
          </div>

          {/* Right Column: Live QR Preview Card */}
          <div className="col-lg-5 d-flex flex-column align-items-center justify-content-center mt-3 mt-lg-0">
            <div
              style={{
                backgroundColor: "#fff",
                padding: "16px",
                borderRadius: "16px",
                boxShadow: "0 10px 25px rgba(0,0,0,0.5)",
                textAlign: "center",
                maxWidth: "240px",
                width: "100%",
                border: "4px solid rgba(56, 189, 248, 0.4)"
              }}
            >
              <div style={{ color: "#0f172a", fontWeight: "bold", fontSize: "0.85rem", marginBottom: "8px" }}>
                {manualQrPreview ? "📷 New QR Preview" : "📱 Active QR Code"}
              </div>

              {manualQrPreview ? (
                <img
                  src={manualQrPreview}
                  alt="QR Preview"
                  style={{ width: "100%", height: "auto", aspectRatio: "1/1", objectFit: "contain", borderRadius: "8px" }}
                />
              ) : ManualQRCode ? (
                <img
                  src={
                    ManualQRCode.startsWith("http")
                      ? ManualQRCode
                      : `${baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl}${ManualQRCode.startsWith("/") ? ManualQRCode : "/" + ManualQRCode}`
                  }
                  alt="Active QR"
                  style={{ width: "100%", height: "auto", aspectRatio: "1/1", objectFit: "contain", borderRadius: "8px" }}
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    if (e.currentTarget.nextSibling) e.currentTarget.nextSibling.style.display = "block";
                  }}
                />
              ) : (
                <div
                  style={{
                    width: "100%",
                    aspectRatio: "1/1",
                    background: "#f1f5f9",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#64748b",
                    padding: "12px"
                  }}
                >
                  <i className="mdi mdi-qrcode" style={{ fontSize: "3rem" }}></i>
                  <span style={{ fontSize: "0.8rem", marginTop: "4px" }}>No QR Uploaded Yet</span>
                </div>
              )}

              <div
                style={{
                  display: "none",
                  width: "100%",
                  aspectRatio: "1/1",
                  background: "#f1f5f9",
                  borderRadius: "8px",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#64748b",
                  padding: "12px"
                }}
              >
                <i className="mdi mdi-image-broken" style={{ fontSize: "2.5rem" }}></i>
                <span style={{ fontSize: "0.8rem" }}>QR Image Not Found</span>
              </div>

              <div
                style={{
                  marginTop: "10px",
                  paddingTop: "8px",
                  borderTop: "1px solid #e2e8f0",
                  fontSize: "0.75rem",
                  color: "#0284c7",
                  fontWeight: "bold",
                  wordBreak: "break-all"
                }}
              >
                {ManualUPIID || "No UPI ID set"}
              </div>
            </div>
          </div>
        </div>
      </form>

      <h5 className="text-uppercase font-weight-bold my-3">UPI Gateway</h5>
      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
        style={{ backgroundColor: "rgba(0, 27, 11, 0.734)", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}
      >
        <div className="form-row">
          <div className="form-group col-md-6">
            <div className="d-flex align-items-center mb-3">
              <label className="mr-3 mb-0" style={{ minWidth: '120px', color: 'white' }}>
                UPI Status:
              </label>
              <button
                type="button"
                className={`btn ${UPIEnabled ? 'btn-success' : 'btn-danger'} ${isLoading ? 'disabled' : ''}`}
                onClick={handleUPIToggle}
                disabled={isLoading}
                style={{
                  minWidth: '100px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                ) : null}
                {UPIEnabled ? 'Active' : 'Disabled'}
              </button>
              <span className="ml-3 text-light">
                {UPIEnabled ? 'UPI payments are currently enabled' : 'UPI payments are currently disabled'}
              </span>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="UPIGatewayKey" style={{ color: 'white' }}>UPI Gateway Key</label>
            <input
              className="form-control"
              type="text"
              value={UPIGatewayKey}
              onChange={(e) => setUPIGatewayKey(e.target.value)}
              placeholder="Enter UPI Gateway Key"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              Update UPI Settings
            </button>
          </div>
        </div>
      </form>

      <h5 className="text-uppercase font-weight-bold my-3">AllAPI Payment Gateway</h5>
      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
        style={{ backgroundColor: "rgba(27, 0, 27, 0.734)", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}
      >
        <div className="form-row">
          <div className="form-group col-md-6">
            <div className="d-flex align-items-center mb-3">
              <label className="mr-3 mb-0" style={{ minWidth: '120px', color: 'white' }}>
                AllAPI Status:
              </label>
              <button
                type="button"
                className={`btn ${AllAPIEnabled ? 'btn-success' : 'btn-danger'} ${isLoading ? 'disabled' : ''}`}
                onClick={handleAllAPIToggle}
                disabled={isLoading}
                style={{
                  minWidth: '100px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                ) : null}
                {AllAPIEnabled ? 'Active' : 'Disabled'}
              </button>
              <span className="ml-3 text-light">
                AllAPI Payment Gateway is currently {AllAPIEnabled ? 'enabled' : 'disabled'}
              </span>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="AllAPIToken" style={{ color: 'white' }}>AllAPI Token</label>
            <input
              className="form-control"
              type="text"
              value={AllAPIToken}
              onChange={(e) => setAllAPIToken(e.target.value)}
              placeholder="Enter AllAPI Token"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              Update AllAPI Settings
            </button>
          </div>
        </div>
      </form>

      <h5 className="text-uppercase font-weight-bold my-3">Fast2SMS Gateway</h5>
      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
        style={{ backgroundColor: "rgba(27, 0, 11, 0.734)", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}
      >
        <div className="form-row">
          <div className="form-group col-md-6">
            <div className="d-flex align-items-center mb-3">
              <label className="mr-3 mb-0" style={{ minWidth: '120px', color: 'white' }}>
                Fast2SMS Status:
              </label>
              <button
                type="button"
                className={`btn ${Fast2SMSEnabled ? 'btn-success' : 'btn-danger'} ${isLoading ? 'disabled' : ''}`}
                onClick={handleFast2SMSToggle}
                disabled={isLoading}
                style={{
                  minWidth: '100px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                ) : null}
                {Fast2SMSEnabled ? 'Active' : 'Disabled'}
              </button>
              <span className="ml-3 text-light">
                Fast2SMS is currently {Fast2SMSEnabled ? 'enabled' : 'disabled'} for OTP delivery
              </span>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-6">
            <label htmlFor="fast2smsKey" style={{ color: 'white' }}>Fast2SMS API Key</label>
            <input
              className="form-control"
              type="text"
              value={fast2smsKey}
              onChange={(e) => setFast2smsKey(e.target.value)}
              placeholder="Enter Fast2SMS API Key"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              Update Fast2SMS Settings
            </button>
          </div>
        </div>
      </form>

      <h5 className="text-uppercase font-weight-bold my-3">Twilio Gateway</h5>
      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
        style={{ backgroundColor: "rgba(0, 11, 27, 0.734)", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}
      >
        <div className="form-row">
          <div className="form-group col-md-6">
            <div className="d-flex align-items-center mb-3">
              <label className="mr-3 mb-0" style={{ minWidth: '120px', color: 'white' }}>
                Twilio Status:
              </label>
              <button
                type="button"
                className={`btn ${TwilioEnabled ? 'btn-success' : 'btn-danger'} ${isLoading ? 'disabled' : ''}`}
                onClick={handleTwilioToggle}
                disabled={isLoading}
                style={{
                  minWidth: '100px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                ) : null}
                {TwilioEnabled ? 'Active' : 'Disabled'}
              </button>
              <span className="ml-3 text-light">
                Twilio is currently {TwilioEnabled ? 'enabled' : 'disabled'} for SMS delivery
              </span>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="TwilioAccountSid" style={{ color: 'white' }}>Twilio Account SID</label>
            <input
              className="form-control"
              type="text"
              value={TwilioAccountSid}
              onChange={(e) => setTwilioAccountSid(e.target.value)}
              placeholder="Enter Twilio Account SID"
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="TwilioAuthToken" style={{ color: 'white' }}>Twilio Auth Token</label>
            <input
              className="form-control"
              type="text"
              value={TwilioAuthToken}
              onChange={(e) => setTwilioAuthToken(e.target.value)}
              placeholder="Enter Twilio Auth Token"
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="TwilioPhoneNumber" style={{ color: 'white' }}>Twilio Phone Number</label>
            <input
              className="form-control"
              type="text"
              value={TwilioPhoneNumber}
              onChange={(e) => setTwilioPhoneNumber(e.target.value)}
              placeholder="Enter Twilio Phone Number"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              Update Twilio Settings
            </button>
          </div>
        </div>
      </form>

      <h5 className="text-uppercase font-weight-bold my-3">OTPless Gateway</h5>
      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
        style={{ backgroundColor: "rgba(27, 27, 0, 0.734)", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}
      >
        <div className="form-row">
          <div className="form-group col-md-6">
            <div className="d-flex align-items-center mb-3">
              <label className="mr-3 mb-0" style={{ minWidth: '120px', color: 'white' }}>
                OTPless Status:
              </label>
              <button
                type="button"
                className={`btn ${OTPlessEnabled ? 'btn-success' : 'btn-danger'} ${isLoading ? 'disabled' : ''}`}
                onClick={handleOTPlessToggle}
                disabled={isLoading}
                style={{
                  minWidth: '100px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                ) : null}
                {OTPlessEnabled ? 'Active' : 'Disabled'}
              </button>
              <span className="ml-3 text-light">
                OTPless is currently {OTPlessEnabled ? 'enabled' : 'disabled'} for SMS delivery
              </span>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="OTPlessClientId" style={{ color: 'white' }}>OTPless Client ID</label>
            <input
              className="form-control"
              type="text"
              value={OTPlessClientId}
              onChange={(e) => setOTPlessClientId(e.target.value)}
              placeholder="Enter OTPless Client ID"
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="OTPlessClientSecret" style={{ color: 'white' }}>OTPless Client Secret</label>
            <input
              className="form-control"
              type="password"
              value={OTPlessClientSecret}
              onChange={(e) => setOTPlessClientSecret(e.target.value)}
              placeholder="Enter OTPless Client Secret"
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="OTPlessEnvironment" style={{ color: 'white' }}>Environment</label>
            <select
              className="form-control"
              value={OTPlessEnvironment}
              onChange={(e) => setOTPlessEnvironment(e.target.value)}
            >
               <option value="production">Production</option>
               <option value="sandbox">Sandbox</option>
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              Update OTPless Settings
            </button>
          </div>
        </div>
      </form>

      <h5 className="text-uppercase font-weight-bold my-3">SMSINDIAHUB Gateway</h5>
      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
        style={{ backgroundColor: "rgba(0, 27, 27, 0.734)", padding: "20px", borderRadius: "8px", marginBottom: "20px" }}
      >
        <div className="form-row">
          <div className="form-group col-md-6">
            <div className="d-flex align-items-center mb-3">
              <label className="mr-3 mb-0" style={{ minWidth: '120px', color: 'white' }}>
                SMSINDIAHUB Status:
              </label>
              <button
                type="button"
                className={`btn ${SMSINDIAHUBEnabled ? 'btn-success' : 'btn-danger'} ${isLoading ? 'disabled' : ''}`}
                onClick={handleSMSINDIAHUBToggle}
                disabled={isLoading}
                style={{
                  minWidth: '100px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                ) : null}
                {SMSINDIAHUBEnabled ? 'Active' : 'Disabled'}
              </button>
              <span className="ml-3 text-light">
                SMSINDIAHUB is currently {SMSINDIAHUBEnabled ? 'enabled' : 'disabled'} for SMS delivery
              </span>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="SMSINDIAHUBAPIKey" style={{ color: 'white' }}>SMSINDIAHUB API Key</label>
            <input
              className="form-control"
              type="text"
              value={SMSINDIAHUBAPIKey}
              onChange={(e) => setSMSINDIAHUBAPIKey(e.target.value)}
              placeholder="Enter SMSINDIAHUB API Key"
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="SMSINDIAHUBSID" style={{ color: 'white' }}>SMSINDIAHUB SID</label>
            <input
              className="form-control"
              type="text"
              value={SMSINDIAHUBSID}
              onChange={(e) => setSMSINDIAHUBSID(e.target.value)}
              placeholder="Enter SMSINDIAHUB SID"
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="SMSINDIAHUBName" style={{ color: 'white' }}>SMSINDIAHUB Name</label>
            <input
              className="form-control"
              type="text"
              value={SMSINDIAHUBName}
              onChange={(e) => setSMSINDIAHUBName(e.target.value)}
              placeholder="Enter SMSINDIAHUB Name (e.g., 22222)"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              Update SMSINDIAHUB Settings
            </button>
          </div>
        </div>
      </form>

      <h5 className="text-uppercase font-weight-bold my-3 text-warning">
        ⚡ LudoRoom Auto Result Gateway (Ludo King)
      </h5>
      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
        style={{
          backgroundColor: "rgba(10, 25, 47, 0.85)",
          padding: "22px",
          borderRadius: "10px",
          marginBottom: "25px",
          border: "1px solid rgba(0, 229, 255, 0.3)"
        }}
      >
        <div className="form-row">
          <div className="form-group col-md-6">
            <div className="d-flex align-items-center mb-3">
              <label className="mr-3 mb-0" style={{ minWidth: '150px', color: 'white', fontWeight: 'bold' }}>
                Auto Result Status:
              </label>
              <button
                type="button"
                className={`btn ${LudoRoomEnabled ? 'btn-success' : 'btn-danger'} ${isLoading ? 'disabled' : ''}`}
                onClick={handleLudoRoomToggle}
                disabled={isLoading}
                style={{
                  minWidth: '110px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease'
                }}
              >
                {isLoading ? (
                  <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                ) : null}
                {LudoRoomEnabled ? 'Active (ON)' : 'Disabled (OFF)'}
              </button>
              <span className="ml-3 text-light" style={{ fontSize: '0.85rem' }}>
                LudoRoom webhook & result verification is currently {LudoRoomEnabled ? 'enabled' : 'disabled'}.
              </span>
            </div>
          </div>

          <div className="form-group col-md-6">
            <div className="d-flex align-items-center mb-3">
              <label className="mr-3 mb-0" style={{ minWidth: '160px', color: 'white', fontWeight: 'bold' }}>
                Auto-Register Room:
              </label>
              <select
                className="form-control"
                style={{ maxWidth: '140px' }}
                value={String(LudoRoomAutoRegister)}
                onChange={(e) => setLudoRoomAutoRegister(e.target.value === 'true')}
              >
                <option value="true">Enabled</option>
                <option value="false">Disabled</option>
              </select>
              <span className="ml-3 text-muted" style={{ fontSize: '0.8rem' }}>
                Subscribes room code to LudoRoom on creation
              </span>
            </div>
          </div>
        </div>

        {/* Webhook URL Box */}
        <div className="form-row mb-3">
          <div className="col-12">
            <div style={{ background: 'rgba(0, 0, 0, 0.4)', padding: '12px 16px', borderRadius: '8px', border: '1px dashed #00e5ff' }}>
              <span className="text-info font-weight-bold">📌 Webhook Callback URL: </span>
              <code style={{ color: '#38ef7d', fontSize: '0.95rem', margin: '0 10px' }}>
                {window.location.protocol}//{window.location.hostname}:7003/api/v1/ludoroom/webhook
              </code>
              <button
                type="button"
                className="btn btn-sm btn-outline-info ml-2"
                onClick={() => {
                  const url = `${window.location.protocol}//${window.location.hostname}:7003/api/v1/ludoroom/webhook`;
                  navigator.clipboard.writeText(url);
                  alert("Webhook URL copied to clipboard: " + url);
                }}
              >
                📋 Copy Webhook URL
              </button>
              <div className="text-muted mt-1" style={{ fontSize: '0.78rem' }}>
                Enter this URL into your <a href="https://ludoroom.in" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff' }}>LudoRoom Dashboard</a> &gt; Webhook Settings.
              </div>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-6">
            <label htmlFor="LudoRoomApiKey" style={{ color: 'white', fontWeight: '600' }}>
              LudoRoom API Key (x-api-key)
            </label>
            <input
              className="form-control"
              type="text"
              id="LudoRoomApiKey"
              value={LudoRoomApiKey}
              onChange={(e) => setLudoRoomApiKey(e.target.value)}
              placeholder="e.g. lr_8178a31557663040334c67367d5269c7..."
            />
            <small className="form-text text-muted">
              Found on your LudoRoom dashboard (starts with <code>lr_</code>).
            </small>
          </div>

          <div className="form-group col-md-6">
            <label htmlFor="LudoRoomWebhookSecret" style={{ color: 'white', fontWeight: '600' }}>
              Webhook Secret Token (Optional)
            </label>
            <input
              className="form-control"
              type="text"
              id="LudoRoomWebhookSecret"
              value={LudoRoomWebhookSecret}
              onChange={(e) => setLudoRoomWebhookSecret(e.target.value)}
              placeholder="Leave empty if none configured in LudoRoom"
            />
            <small className="form-text text-muted">
              Security token if configured in your LudoRoom webhook settings.
            </small>
          </div>
        </div>

        {/* Test Connection Result */}
        {ludoroomMsg && (
          <div className="alert alert-info py-2 px-3 mb-3" style={{ fontSize: '0.9rem' }}>
            {ludoroomMsg}
            {ludoroomProfile && (
              <div className="mt-2 text-white" style={{ fontSize: '0.85rem' }}>
                <div><strong>Account:</strong> {ludoroomProfile.name || ludoroomProfile.email || 'Verified Account'}</div>
                <div><strong>Available Credits:</strong> <span className="badge badge-success">{ludoroomProfile.credits !== undefined ? ludoroomProfile.credits : 'N/A'}</span></div>
                {ludoroomProfile.wallet && (
                  <div><strong>Remaining Requests:</strong> {ludoroomProfile.wallet.requestsRemaining || 0}</div>
                )}
              </div>
            )}
          </div>
        )}

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary mr-3">
              Save LudoRoom Settings
            </button>
            <button
              type="button"
              className="btn btn-outline-info"
              onClick={testLudoRoomConnection}
              disabled={ludoroomLoading || !LudoRoomApiKey}
            >
              {ludoroomLoading ? 'Testing...' : '⚡ Test Connection & Credits'}
            </button>
          </div>
        </div>
      </form>

      <h5 className="text-uppercase font-weight-bold my-3">RazorPay</h5>

      <form
        action="gatewaysettings"
        className="form"
        onSubmit={handleSubmit1}
        method="patch"
        encType="multipart/form-data"
      >
        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="buttonrazpay">Razorpay Payout</label>
            <select
              id="buttonrazpay"
              className="form-control"
              value={RazorPayout}
              onChange={(e) => setRazorpayout(e.target.value === "true")}
            >
              <option value="true">Enable</option>
              <option value="false">Disable</option>
            </select>
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="buttonrazdep">Razorpay Deposit</label>
            <select
              id="buttonrazdep"
              className="form-control"
              value={RazorDeposit}
              onChange={(e) => setRazorDeposit(e.target.value === "true")}
            >
              <option value="true">Enable</option>
              <option value="false">Disable</option>
            </select>
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="buttonrazauto">RazorPay Auto</label>
            <select
              id="buttonrazauto"
              className="form-control"
              value={RazorpayAuto}
              onChange={(e) => setRazorpayAuto(e.target.value === "true")}
            >
              <option value="true">Enable</option>
              <option value="false">Disable</option>
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md-4">
            <label htmlFor="RazorpayKey">RazorPay Key</label>
            <input
              className="form-control"
              type="text"
              value={RazorPayKey}
              onChange={(e) => setRazorpayKey(e.target.value)}
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="RazorpaysecretKey">RazorPay SecretKey</label>
            <input
              className="form-control"
              type="text"
              value={RazorPaySecretKey}
              onChange={(e) => setRazorpaysecretKey(e.target.value)}
            />
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="AccountName">Account Name</label>
            <input
              className="form-control"
              type="text"
              value={AccountName}
              onChange={(e) => setAccountName(e.target.value)}
            />
          </div>
        </div>

        {/* <div className="form-row">
          <div className="form-group col-md-4">
            <h5 className="text-uppercase font-weight-bold my-3">Decentro</h5>

            <label htmlFor="buttondecpay" className="col-2 my-1">
              Decentro payout
            </label>
            <select
              className="form-control "
              name=""
              id=""
              value={decentroPayout}
              onChange={(e) => setdecentropayout(e.target.value)}
            >
              <option value="true">Enable</option>
              <option value="false">Disable</option>
            </select>

            <label htmlFor="buttondecdep" className="col-2 my-1">
              Decentro Deposit
            </label>
            <select
              className="form-control "
              name=""
              id=""
              value={decentroDeposit}
              onChange={(e) => setdecentroDeposit(e.target.value)}
            >
              <option value="true">Enable</option>
              <option value="false">Disable</option>
            </select>

            <label htmlFor="buttondecdep" className="col-2 my-1">
              Decentro Auto
            </label>
            <select
              className="form-control "
              name=""
              id=""
              value={decentroAuto}
              onChange={(e) => setdecentroAuto(e.target.value)}
            >
              <option value="true">Enable</option>
              <option value="false">Disable</option>
            </select>
          </div>
        </div> */}

        <div className="form-row">
          <div className="form-group col-md-4">
            <button type="submit" className="btn btn-primary">
              RazorPay Settings Update
            </button>
          </div>
        </div>


      </form>
    </>
  );
};

export default Gateway;
